export default __webpack_public_path__ + "static/media/event_img.66ee89f9.jpeg";